import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import { Menu } from '@wds/menu';
import { IconCaretDown } from '@wds/icons';
import NestedCategoryMenu, { categoryShape, categoryHeaderShape } from './nestedCategoryMenu';

const CategoryPicker = (props) => {
    const {
        className,
        categoryList,
        category,
        setCategory,
    } = props;

    const [showDropdown, setShowDropdown] = React.useState(false);

    const onChange = (data) => {
        handleClick();
        setCategory(data);
    };

    const handleClick = () => setShowDropdown(!showDropdown)

    const ControlledMenuTrigger = (
        <div>
            <Box id="sma-helpdesk-category-select-trigger" display="flex" justifyContent="space-between">
                <div>{category === null ? (gettext('Choose...')) : (category.label)}</div>
                <div><IconCaretDown/></div>
            </Box>
        </div>

    )

    return (
        <div className={className} id="sma-helpdesk-category-picker">
            <label className="wds-label">{gettext('Select the area of the product this is related to')}</label>
            <Menu
                menuTrigger={ControlledMenuTrigger}
                onChange={handleClick}
                show={showDropdown}
                noRules
                stretched
                variant="panel"
                autoClose={false}
            >
                <Menu.Body>
                    <NestedCategoryMenu
                        categoryList={categoryList}
                        onChange={onChange}
                    />
                </Menu.Body>
            </Menu>
        </div>
    );
};

CategoryPicker.propTypes = {
    className: PropTypes.string,
    categoryList: PropTypes.arrayOf(categoryHeaderShape).isRequired,
    category: categoryShape,
    setCategory: PropTypes.func.isRequired,
};

CategoryPicker.defaultProps = {
    className: '',
    category: {},
};

export default CategoryPicker;
